import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { getSsoRedirectUrl } from '../getSsoRedirectUrl';
import { ItaliaButton } from '../italia-button/ItaliaButton';

const cieIco = require('./img/cie-icon.png').default;

export interface CieAccessButtonProps {}

/**
 * Pulsante CIE
 */
export function CieLoginButton(props: CieAccessButtonProps) {
  const { t } = useTranslation();

  return (
    <a href={getSsoRedirectUrl('cie')}>
      <ItaliaButton
        image={cieIco}
        text={t('user.login.cie-button', 'Entra con CIE')}
      />
    </a>
  );
}
